import { InitiativeCategory } from '../../../../../../../common/enums/policy-initiative/initiative-category.enum'

export const step1Order = [
  'gaiinCountry',
  'intergovernmentalOrganisation',
  'englishName',
  'originalName',
  'description',
  'status',
  'startYear',
  'category',
  'initiativeType',
  'budgetAvailable',
  'budget',
  'hasMonitoringMechanism',
  'monitoringMechanismDescription',
  'principles',
  'overview'
]

export const commonStep1Fields = [
  'englishName',
  'originalName',
  'description',
  'status',
  'startYear',
  'category',
  'initiativeType',
  'endYear',
  'targetSectors',
  'tags',
  'principles',
  'overview'
]

export const commonStep3Fields = [
  'sourceFiles',
  'relevantUrls',
  'images',
  'relevantFiles',
  'moreInfos'
]

export const IntergovernmentalPolicyFrameworksFields = [
  'intergovernmentalOrganisation',
  'extentBinding',
  'budgetAvailable',
  'budget'
]

export const IntergovernmentalGovernanceFields = [
  'intergovernmentalOrganisation'
]

export const NationalStrategyFields = [
  'gaiinCountry',
  'responsibleOrganisation',
  'engagementMechanisms',
  'budgetAvailable',
  'budget',
  'hasMonitoringMechanism',
  'monitoringMechanismDescription'
]

export const NationalStrategyStep2Fields = [
  'isEvaluated',
  'evaluationBy',
  'evaluationResultsIsPubliclyAvailable',
  'evaluationUrls',
  'evaluationFiles',
  'evaluationDescription'
]

export const NationalGovernanceFields = [
  'gaiinCountry',
  'budgetAvailable',
  'budget'
]

export const NationalRegulationsFields = [
  'gaiinCountry',
  'extentBinding',
  'budgetAvailable',
  'budget'
]

export const NationalProgrammesFields = [
  'gaiinCountry',
  'budgetAvailable',
  'budget',
  'hasMonitoringMechanism',
  'monitoringMechanismDescription'
]

export const fieldDefinition: Map<InitiativeCategory, string[]> = new Map([
  [
    InitiativeCategory.IntergovernmentalPolicyFrameworks,
    [
      ...commonStep1Fields,
      ...IntergovernmentalPolicyFrameworksFields,
      ...commonStep3Fields
    ]
  ],
  [
    InitiativeCategory.IntergovernmentalGovernance,
    [
      ...commonStep1Fields,
      ...IntergovernmentalGovernanceFields,
      ...commonStep3Fields
    ]
  ],
  [
    InitiativeCategory.NationalStrategy,
    [
      ...commonStep1Fields,
      ...NationalStrategyStep2Fields,
      ...NationalStrategyFields,
      ...commonStep3Fields
    ]
  ],
  [
    InitiativeCategory.NationalGovernance,
    [...commonStep1Fields, ...NationalGovernanceFields, ...commonStep3Fields]
  ],
  [
    InitiativeCategory.NationalRegulations,
    [...commonStep1Fields, ...NationalRegulationsFields, ...commonStep3Fields]
  ],
  [
    InitiativeCategory.NationalProgrammes,
    [...commonStep1Fields, ...NationalProgrammesFields, ...commonStep3Fields]
  ]
])
